export var WtuReason;
(function (WtuReason) {
    WtuReason["Broken"] = "Broken";
})(WtuReason || (WtuReason = {}));
